import { Eye, SquarePen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { PARAMS } from '@/utils/params';
import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { PlannerEnv } from '@/utils/env';
import { Fragment } from 'react/jsx-runtime';
import { useUser } from '@/components/providers/user-provider';

export type PlannerListNavigationProps = {
  env: PlannerEnv;
  planner: PlannerConfigEntity;
};

export function PlannerListNavigation({
  env,
  planner,
}: PlannerListNavigationProps) {
  return (
    <Fragment>
      {env === 'cte' ? <PlannerEditLink env={env} planner={planner} /> : null}
      <Link to={`/planner/view/${env}/${planner.id}`}>
        <Button
          variant='ghost'
          className={`float-right gap-2 h-8`}
          icon={<Eye className='h-5 w-5' />}
        >
          View
        </Button>
      </Link>
    </Fragment>
  );
}

type PlannerEditLinkProps = PlannerListNavigationProps;
function PlannerEditLink({ planner }: PlannerEditLinkProps) {
  const user = useUser();
  return (
    <>
      {user.role !== 'viewer' && (
        <Link
          to={`/planner/draft?${PARAMS.FROM_IDENTIFIER}=${planner.identifier}&${PARAMS.PROMPT_TO_SELECT_DRAFT}=true`}
        >
          <Button
            variant='ghost'
            className={`float-right gap-2 h-8`}
            icon={<SquarePen className='h-5 w-5' />}
          >
            Edit
          </Button>
        </Link>
      )}
    </>
  );
}
